import React, { useState, useEffect, useRef } from "react";
import "./Deposit.css";
// import "../../../src/App.css";
import "../Withdraw/Withdraw.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFileUpload } from "react-icons/fa";
import Header from "../header/Header";
import Helper from "../../helper";
import Appconfig from '../../config/config'
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getPaymentMethods } from '../../redux/slice/paymentMethod/paymentMethodSlice';
import { useSelector, useDispatch } from 'react-redux';
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import { Modal, Input, Table, Image, Button, Switch } from 'antd';
import { EyeOutlined } from "@ant-design/icons";



const Deposit = () => {
  const navigate = useNavigate();
  const userInfo = Helper();
  const dispatch = useDispatch();
  const userInfos = useSelector((state) => state.paymentMethods); // Use selector to access state
  const paymentMethod = userInfos?.paymentMethods || [];
  const usdtMethods = paymentMethod.filter(pm => pm.type === "USDT");
  // console.log('USDT Methods:', usdtMethods);

  const [amountValue, setAmountValue] = useState("");
  const [utrValue, setUTRValue] = useState("");

  const [selectedOption, setSelectedOption] = useState("");
  const [methodDetail, setMethodDetail] = useState("");
  const [depositHistory, setDepositHistory] = useState([]);


  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [buttonText, setButtonText] = useState("Submit"); // State for button text
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [imageList, setImageList] = useState(null); // State to store the image list
  const [showDepositHistory, setShowDepositHistory] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  const [balance, setBalance] = useState(0)
  const [exposure, setExposure] = useState(0)
  let balanceWithExp = balance - Math.abs(exposure);
  const [buttonValues, setButtonValues] = useState([500, 1000, 2000, 5000, 10000, 15000]);
  const [isEditing, setIsEditing] = useState(false);
  const [showAllRules, setShowAllRules] = useState(false);
  const notesRef = useRef(null);
  const historyRef = useRef(null);

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = (img) => {
    setPreviewImage(img);
    setPreviewVisible(true);
  };

  const rules = [
    "1. Deposit money only in the below available accounts to get the fastest credits and avoid possible delays.",
    "2. Deposits made 45 minutes after the account removal from the site are valid & will be added to their wallets.",
    "3. Site is not responsible for money deposited to Old, Inactive or Closed accounts.",
    "4. After deposit, add your UTR and amount to receive balance.",
    "5. NEFT receiving time varies from 40 minutes to 2 hours."
  ];

  const handleCopy = (value) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    toast.success("Copied to clipboard");
  };

  const handleEditToggle = () => {
    if (isEditing) {
      // User is trying to save
      const hasEmpty = buttonValues.some((v) => v === '' || isNaN(v));
      if (hasEmpty) {
        alert('Please fill all the amount fields before saving!');
        return; // Do not toggle if validation fails
      }
    }
    setIsEditing(!isEditing);
  };

  const handleInputChange = (index, newValue) => {
    const updatedValues = [...buttonValues];
    updatedValues[index] = newValue; // Keep as string
    setButtonValues(updatedValues);
  };

  const handleButtonClick = (value) => {
    // Use Number() only here!
    const addAmount = Number(value) || 0;
    const currentAmount = Number(amountValue) || 0;
    setAmountValue(currentAmount + addAmount);
  };

  // const historyColumns = [
  //   {
  //     title: 'User Name',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {record?.user_name}
  //       </span>
  //     ),
  //   },
  //   // {
  //   //   title: 'User Id',
  //   //   sorter: true,
  //   //   render: (_, record) => (
  //   //     <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //   //       {record?.user_id}
  //   //     </span>
  //   //   ),
  //   // },
  //   {
  //     title: 'Type',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {record?.type}
  //       </span>
  //     ),
  //   },
  //   ...(depositHistory.some((record) => record.bank_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Bank Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.bank_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(depositHistory.some((record) => record.account_no) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Account Num',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.account_no || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(depositHistory.some((record) => record.account_holder_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Account Holder Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.account_holder_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(depositHistory.some((record) => record.ifsc_code) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'IFSC Code',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.ifsc_code || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(depositHistory.some((record) => record.upi_id) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'UPI Id',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.upi_id || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(depositHistory.some((record) => record.holder_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Holder Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //             {record?.holder_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   {
  //     title: 'Remarks',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {record?.remark}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Amount',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {record?.amount}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Screen Shot',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {
  //           record?.screenshot_name == null ? "No Screenshot" : <Image
  //             width={70}
  //             src={`${Appconfig.apiUrl}deposit/${record?.screenshot_name}`}
  //           />
  //         }

  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'UTR Number',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {
  //           record?.utr_number
  //         }
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Request Date',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {(new Date(record?.createdAt)).toLocaleString()}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Status',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className={`font-extrabold text-[#212529] text-[0.813rem] ml-[5px] ${record?.status == 'Reject' ? 'text-[red]' : 'text-[green]'}`}>
  //         {record?.status}
  //       </span>
  //     ),
  //   },
  // ];

  const historyColumns = [
    {
      title: "User Name",
      sorter: true,
      render: (_, record) => (
        <span className="font-semibold text-gray-800 text-sm">{record?.user_name}</span>
      ),
    },
    {
      title: "Type",
      sorter: true,
      render: (_, record) => (
        <span className="font-medium text-gray-700 text-sm">{record?.type}</span>
      ),
    },
    ...(depositHistory.some((r) => r.bank_name)
      ? [
          {
            title: "Bank Name",
            sorter: true,
            render: (_, record) => (
              <span className="font-medium text-gray-700 text-sm">
                {record?.bank_name || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(depositHistory.some((r) => r.account_no)
      ? [
          {
            title: "Account Num",
            sorter: true,
            render: (_, record) => (
              <span className="font-medium text-gray-700 text-sm">
                {record?.account_no || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(depositHistory.some((r) => r.account_holder_name)
      ? [
          {
            title: "Account Holder Name",
            sorter: true,
            render: (_, record) => (
              <span className="font-medium text-gray-700 text-sm">
                {record?.account_holder_name || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(depositHistory.some((r) => r.ifsc_code)
      ? [
          {
            title: "IFSC Code",
            sorter: true,
            render: (_, record) => (
              <span className="font-medium text-gray-700 text-sm">
                {record?.ifsc_code || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(depositHistory.some((r) => r.upi_id)
      ? [
          {
            title: "UPI Id",
            sorter: true,
            render: (_, record) => (
              <span className="font-medium text-gray-700 text-sm">
                {record?.upi_id || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    {
      title: "Remarks",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-600 text-sm">{record?.remark}</span>
      ),
    },
    {
      title: "Amount",
      sorter: true,
      render: (_, record) => (
        <span className="font-bold text-gray-900 text-sm">₹ {record?.amount}</span>
      ),
    },
    {
      title: "Screenshot",
      sorter: false,
      render: (_, record) =>
        record?.screenshot_name ? (
          <Button
            type="primary"
            icon={<EyeOutlined />}
            className="flex items-center gap-1 bg-[#0c9971] hover:!bg-[#0a7c5c] border-none"
            onClick={() =>
              handlePreview(`${Appconfig.apiUrl}deposit/${record?.screenshot_name}`)
            }
          >
            View
          </Button>
        ) : (
          <span className="text-gray-400 text-xs">No Screenshot</span>
        ),
    },
    {
      title: "UTR Number",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-700 text-sm">{record?.utr_number}</span>
      ),
    },
    {
      title: "Request Date",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-600 text-sm">
          {new Date(record?.createdAt).toLocaleString()}
        </span>
      ),
    },
    {
      title: "Status",
      sorter: true,
      render: (_, record) => (
        <span
          className={`font-semibold text-sm ${
            record?.status === "Reject" ? "text-red-500" : "text-green-600"
          }`}
        >
          {record?.status}
        </span>
      ),
    },
  ];

  const getDepositHistory = () => {

    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      user_id: userInfo?._id
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}deposit/getDepositHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setDepositHistory(response.data.resultData);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  };

  useEffect(() => { getDepositHistory() }, []);

  // Function to handle button click
  // const handleButtonClick = (value) => {
  //   // Convert both to numbers and add
  //   const currentAmount = Number(amountValue) || 0;
  //   const addAmount = Number(value) || 0;
  //   setAmountValue(currentAmount + addAmount);
  // };

  // Function to handle payment option click
  const handleClick = (option, detail) => {
    setSelectedOption(option);
    setMethodDetail(detail);
  };

  // Button values
  // const buttonValues = [500, 1000, 1500, 2000, 2500, 3000];

  const listRef = useRef(null); // Ref to target the scrolling list

  const scrollLeft = () => {
    listRef.current.scrollBy({
      left: -300, // Scroll left by 150px
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    listRef.current.scrollBy({
      left: 300, // Scroll right by 150px
      behavior: "smooth",
    });
  };



  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo])

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance)
          setExposure(response.data.resultData?.exposure)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  // useEffect(() => {
  //   dispatch(getPaymentMethods({
  //     site_code: Appconfig.sitecodes,
  //     user_id: Appconfig.superAdmin
  //   }));
  // }, [])

  useEffect(() => {
    dispatch(
      getPaymentMethods({
        site_code: Appconfig.sitecodes,
        user_id: userInfo?.master_id ? userInfo?.master_id : Appconfig.superAdmin,
      })
    );
  }, []);


  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX); // Get the starting X position of the touch
  };

  // Handle touch move
  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX); // Get the X position during the swipe
  };

  // Handle touch end
  const handleTouchEnd = () => {
    const touchDiff = touchStartX - touchEndX;

    if (touchDiff > 50) {
      // Swipe left (scroll right)
      scrollRight();
    } else if (touchDiff < -50) {
      // Swipe right (scroll left)
      scrollLeft();
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // File size limit (2MB)
    const maxSize = 2 * 1024 * 1024; // 2MB
    // Allowed types
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

    if (file.size > maxSize) {
      toast.error("File size is too big. Maximum allowed is 2MB.", { autoClose: 2000 });
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      toast.error("File format not supported. Allowed: JPG, JPEG, PNG, WEBP.", { autoClose: 2000 });
      return;
    }
    setImageList(file);
  }

  // Handle submit click and toggle button text & style
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    // Field validation
    if (!amountValue) {
      toast.error("Amount is required!", { autoClose: 2000 });
      return;
    }
    if (!utrValue) {
      toast.error("UTR/RRN Number is required!", { autoClose: 2000 });
      return;
    }
    if (!imageList) {
      toast.error("Payment screenshot is required!", { autoClose: 2000 });
      return;
    }
    if (!selectedOption) {
      toast.error("Please select a payment method!", { autoClose: 2000 });
      return;
    }

    if (userInfo && selectedOption && amountValue) {
    } else {
      toast.error("Please fill all the fields!", { autoClose: 2000 });
    }

    if (userInfo && selectedOption && amountValue) {

      const formData = new FormData();

      formData.append("master_id", userInfo?.master_id);
      formData.append("user_id", userInfo?._id);
      formData.append("site_code", userInfo?.site_code);
      formData.append("user_name", userInfo?.user_name);
      formData.append("type", selectedOption);
      formData.append("bank_name", methodDetail?.bankName);
      formData.append("account_no", methodDetail?.accountNo);
      formData.append("account_holder_name", methodDetail?.accountHolder);
      formData.append("ifsc_code", methodDetail?.ifscCode);
      formData.append("holder_name", methodDetail?.holderName);
      formData.append("upi_id", methodDetail?.upiId);
      formData.append("amount", amountValue);
      formData.append("utr_number", utrValue);
      formData.append("admin_mobile_number", Appconfig.admin_mobile_number);
      formData.append("file", imageList); // Include the uploaded file

      var config = {
        method: 'post',
        url: `${Appconfig.apiUrl}deposit/addDepositRequest`,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      };
      axios(config)
        .then(function (response) {
          if (response.data.result) {
            setButtonText("Thanks");
            setIsSubmitted(true);
            toast.success(response.data.resultMessage, { autoClose: 2000 });

            setTimeout(() => {
              navigate("/");
            }, 2000);

          } else {
            toast.error(response.data.resultMessage, { autoClose: 2000 });
          }

        })
        .catch(function (error) {
          console.log(error);
        });

    }

  };

  const CopyIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="var(--icon-color-brand-secondary)"
    >
      <g clipPath="url(#clip0)">
        <path d="M8.50391 14H3.28125C2.07503 14 1.09375 13.0187 1.09375 11.8125V4.40234C1.09375 3.19612 2.07503 2.21484 3.28125 2.21484H8.50391C9.71013 2.21484 10.6914 3.19612 10.6914 4.40234V11.8125C10.6914 13.0187 9.71013 14 8.50391 14ZM3.28125 3.30859C2.67819 3.30859 2.1875 3.79929 2.1875 4.40234V11.8125C2.1875 12.4156 2.67819 12.9062 3.28125 12.9062H8.50391C9.10696 12.9062 9.59766 12.4156 9.59766 11.8125V4.40234C9.59766 3.79929 9.10696 3.30859 8.50391 3.30859H3.28125ZM12.8789 10.4453V2.1875C12.8789 0.981277 11.8976 0 10.6914 0H4.62109C4.31903 0 4.07422 0.244812 4.07422 0.546875C4.07422 0.848938 4.31903 1.09375 4.62109 1.09375H10.6914C11.2945 1.09375 11.7852 1.58444 11.7852 2.1875V10.4453C11.7852 10.7474 12.03 10.9922 12.332 10.9922C12.6341 10.9922 12.8789 10.7474 12.8789 10.4453Z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  // Add this effect to auto-select the first payment method
  useEffect(() => {
    if (paymentMethod?.length > 0 && !selectedOption) {
      setSelectedOption(paymentMethod[0].type);
      handleClick(paymentMethod[0].type, paymentMethod[0]); // optional logic
    }
  }, [paymentMethod]);

  const handleToggleNotes = () => {
    setShowNotes((prev) => {
      const newValue = !prev;
      if (!prev) {
        // Wait until state updates and DOM renders
        setTimeout(() => {
          notesRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      return newValue;
    });
  };

  const handleToggleHistory = () => {
    setShowDepositHistory((prev) => {
      const newValue = !prev;
      if (!prev) {
        setTimeout(() => {
          historyRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      return newValue;
    });
  };



  return (
    <>
      {/* <Header /> */}
      {/* <ExposureHeader /> */}
      <div className="deposit-withdraw text-[#000]">
        <div className=" lg:flex sticky top-0  app-bg font-lato-bold w-full justify-between items-center lg:pt-0">
          <div>
            <nav
              className="flex items-center justify-center w-max space-x-1 text-sm text-white/80 p-2"
              aria-label="Breadcrumb"
            >
              <a title="LotusPlus365-Home" className="flex items-center" href="/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 576 512"
                  fill="var(--icon-color-brand-secondary1)"
                >
                  <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
                </svg>
              </a>
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="var(--icon-color-tertiary2)"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M9 6l6 6l-6 6"></path>
                </svg>
                <a
                  className="ml-1 text-lg transition-all ease-in-out duration-300 text-text_brand_primary font-semibold hover:underline"
                  aria-current="page"
                  title="LotusPlus365-Deposit"
                  href="/deposit"
                >
                  Deposit
                </a>
              </div>
            </nav>
          </div>
        </div>


        {/* <div className="rounded-lg bg-bg_color_primary overflow-hidden text-text_color_primary1 transition-height duration-500 ease-in-out h-max px-3 pt-[15px] pb-[20px]">
          <div className="flex flex-row justify-end items-center w-full">
            <span className="text-base font-lato font-bold leading-5 w-full">
              Payment Options
              <button
                className="relative overflow-hidden ml-1 size-6 rounded-full text-text_color_success font-bold text-sm leading-4 bg-bg_color_success1 border border-success shadow-sm"
                type="button"
              >
                {paymentMethod.length}
              </button>
            </span>
            <button
              className="relative overflow-hidden flex size-[22px] sm:size-[24px] md:size-[26px] justify-center items-center gap-[10px] bg-bg_color_quaternary rounded shadow-sm"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M15 6l-6 6l6 6"></path>
              </svg>
            </button>
            <button
              className="relative overflow-hidden flex size-[22px] sm:size-[24px] md:size-[26px] justify-center ml-[4px] items-center gap-[10px] bg-bg_color_quaternary rounded shadow-sm"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </button>
          </div>

          <div id="payMentOptions" className="flex items-center gap-x-2 pt-3 pb-2.5 overflow-x-auto no-scrollbar scroll-smooth cursor-pointer w-full transition-all ease-in-out duration-150">
            {paymentMethod?.length > 0 && paymentMethod.map((item, index) => {
              const isActive = selectedOption === item.type;
              const imgSrc =
                item.type === "Bank" ? "/Images/bank-transfer.png" :
                item.type === "UPI" ? "/Images/UPI-Color.webp" :
                item.type === "Gpay" ? "/Images/G-pay.webp" :
                item.type === "Phonepe" ? "/Images/phonepe.webp" :
                item.type === "Paytm" ? "/Images/paytm.webp" :
                "";

              return (
                <div
                  key={index}
                  onClick={() => handleClick(item.type, item)}
                  className={`overflow-hidden h-full min-w-max relative border rounded-[10px] px-4 py-2 gap-x-2.5 transition-all duration-200 ease-in-out hover:shadow-sm ${isActive ? "border-border_color_brand_primary shadow-depositGateWayBoxShadows" : "border-border_color_depositPaymentMethod"} bg-bg_color_primary`}
                >
                  <div className="flex flex-col sm:flex-row items-center sm:justify-between gap-y-2 sm:gap-x-4 min-w-max">
                    <div className="flex items-start justify-between w-full gap-x-0">
                      <div className="relative overflow-hidden object-contain h-auto max-w-[70px] max-h-[25px]">
                        <img
                          src={imgSrc}
                          alt={item.type}
                          className="w-full h-full"
                          loading="lazy"
                        />
                      </div>
                      <div className="sm:absolute top-2 right-2">
                        <div className="inline-flex items-center">
                          <label className="relative flex cursor-pointer items-center rounded-full">
                            <input
                              type="checkbox"
                              checked={isActive}
                              readOnly
                              style={{ width: "20px", height: "20px" }}
                              className="peer relative cursor-pointer appearance-none rounded-full border border-border_color_primary transition-all checked:border-border_color_brand_primary checked:bg-bg_text_brand_primary"
                            />
                            <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-text_color_primary2 opacity-0 transition-opacity peer-checked:opacity-100">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-y-1 min-w-[100px] max-w-[110px]">
                      <span className="font-lato font-bold truncate w-full uppercase text-left text-xs sm:text-sm">
                        {item.label || item.type}
                      </span>
                      <div className="flex w-full gap-x-1 sm:gap-x-3 items-start sm:items-center text-xs text-text_color_primary6 sm:text-text_color_primary">
                        <div className="flex sm:flex-col gap-y-0.5">
                          <span className="hidden sm:block">Min</span>
                          <span className="font-bold whitespace-nowrap">₹ {item.min || "200"}</span>
                        </div>
                        <div className="block sm:hidden">-</div>
                        <div className="flex sm:flex-col gap-y-0.5">
                          <span className="hidden sm:block">Max</span>
                          <span className="font-bold whitespace-nowrap">₹ {item.max || "1,00,000"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <p className="text-xs md:text-sm pt-2 font-lato font-normal leading-4">
            1. Deposit money only in the below available accounts to get the fastest credits and avoid possible delays.
          </p>
        </div> */}


        {/* Conditionally render the divs based on the selected option */}
        <div className="payment-details">


          <form className="details mt-2" onSubmit={handleSubmitClick} >
            <div className="w-full py-[15px] rounded-lg bg-bg_color_primary px-3">
              <div className="w-full mb-2">
                <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                  Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                </span>
              </div>
              <label
                htmlFor="amount"
                className="font-lato font-bold text-text_color_primary1 text-base leading-5"
              >
                Amount
              </label>

              {/* Main amount input */}
              <div className="w-full mt-2 py-2 bg-bg_color_input_bg grid grid-cols-12 border rounded-[4px] px-2 items-center justify-center border-border_color_success font-semibold">
                <input
                  id="amount"
                  type="number"
                  value={amountValue}
                  onChange={(e) => setAmountValue(e.target.value)}
                  placeholder="₹ Enter Amount"
                  required
                  autoComplete="off"
                  className="block w-full focus:outline-none col-span-11 text-text_color_primary1 bg-transparent font-lato placeholder:font-lato placeholder:font-normal font-bold text-base border-none p-0"
                />
                <span className="font-lato font-bold leading-4 text-text_color_primary1 text-base col-span-1 text-center font-semibold">
                  INR
                </span>
              </div>

              <div className="text-x pl-1 mt-0 text-text_color_primary1 font-lato">
                <span>Min 100</span>
                <span> - Max 5,00,000</span>
              </div>

              {/* Buttons or Editable Inputs */}
              <div className="w-full grid grid-cols-3 gap-[10px] mt-[18px]">
                {buttonValues.map((value, index) =>
                  isEditing ? (
                    <input
                      key={index}
                      type="number"
                      value={value}
                      onChange={(e) => handleInputChange(index, Number(e.target.value))}
                      className="relative overflow-hidden bg-white transition-all ease-in-out duration-300 text-text_color_primary1 min-h-9 text-base font-lato rounded-md font-[800] leading-4 text-center border border-gray-300"
                    />
                  ) : (
                    <button
                      key={index}
                      type="button"
                      className="relative overflow-hidden bg-bg_text_brand_primary transition-all ease-in-out duration-300 active:scale-95 text-text_color_primary2 min-h-9 text-base font-lato rounded-md font-[600] leading-4"
                      onClick={() => handleButtonClick(value)}
                    >
                      <span>+{value}</span>
                    </button>
                  )
                )}
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="button"
                  onClick={handleEditToggle}
                  className="px-4 py-2 bg-[#0c9971] text-white rounded-md font-lato font-semibold"
                >
                  {isEditing ? "Save" : "Edit"}
                </button>
              </div>
            </div>

            <div className="my-2 rounded-lg bg-bg_color_primary overflow-hidden text-text_color_primary1 transition-height duration-500 ease-in-out h-max px-3 pt-[15px] pb-[20px]">
              <div className="flex flex-row justify-end items-center w-full">
                <span className="text-base font-lato font-bold leading-5 w-full">
                  Payment Options
                  <button
                    className="relative overflow-hidden ml-1 size-6 rounded-full text-text_color_success font-bold text-sm leading-4 bg-bg_color_success1 border border-success shadow-sm"
                    type="button"
                  >
                    {paymentMethod.length}
                  </button>
                </span>
                <button
                  className="relative overflow-hidden flex size-[22px] sm:size-[24px] md:size-[26px] justify-center items-center gap-[10px] bg-bg_color_quaternary rounded shadow-sm"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15 6l-6 6l6 6"></path>
                  </svg>
                </button>
                <button
                  className="relative overflow-hidden flex size-[22px] sm:size-[24px] md:size-[26px] justify-center ml-[4px] items-center gap-[10px] bg-bg_color_quaternary rounded shadow-sm"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 6l6 6l-6 6"></path>
                  </svg>
                </button>
              </div>

              <div
                id="payMentOptions"
                className="flex items-center gap-x-2 pt-3 pb-2.5 overflow-x-auto no-scrollbar scroll-smooth cursor-pointer w-full transition-all ease-in-out duration-150 pl-2"
              >
                {paymentMethod?.length > 0 &&
                  paymentMethod.map((item, index) => {
                    const isActive = selectedOption === item.type;
                    const imgSrc =
                      item.type === "Bank"
                        ? "/Images/bank.png"
                        : item.type === "UPI"
                          ? "/Images/icons8-bhim-50.svg"
                          : item.type === "Gpay"
                            ? "/Images/icons8-google-pay.svg"
                            : item.type === "Phonepe"
                              ? "/Images/icons8-phone-pe.svg"
                              : item.type === "Paytm"
                                ? "/Images/icons8-paytm.svg"
                                : item.type === "QRCODE"
                                  // ? Appconfig.apiUrl + '/Images/qr.svg' + item.qrCode
                                  ?  '/Images/qr.svg'
                                  : item.type === "USDT"
                                    ? "/Images/usdt.png"
                                    : "";

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          setSelectedOption(item.type);
                          handleClick(item.type, item);
                        }}
                        className={`relative flex flex-col items-center justify-center gap-1 min-w-[120px] px-3 py-2 rounded-[10px] border border-border_color_depositPaymentMethod text-center bg-bg_color_primary cursor-pointer overflow-hidden`}
                      >
                        {isActive && (
                          <svg
                            className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="none"
                          >
                            <rect
                              x="1"
                              y="1"
                              width="98"
                              height="98"
                              rx="10"
                              ry="10"
                              fill="none"
                              stroke="#0c9971"
                              strokeWidth="2"
                              strokeDasharray="400"
                              strokeDashoffset="400"
                              className="animate-borderDraw"
                            />
                          </svg>
                        )}

                        {/* content */}
                        <div className="w-full h-[40px] flex items-center justify-center">
                          <img
                            src={imgSrc}
                            alt={item.type}
                            className="object-contain max-h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <span className="font-lato font-bold text-xs uppercase truncate">
                          {item.label || item.type}
                        </span>
                      </div>

                    );
                  })}
              </div>



              <div className="">
                <ul className="list-disc text-xs md:text-sm pt-2 font-lato font-normal leading-4">
                  {showAllRules ? (
                    rules.map((rule, idx) => <li key={idx} className="mb-1">{rule}</li>)
                  ) : (
                    <li>{rules[0]}</li>
                  )}
                </ul>
                <button
                  type="button"
                  onClick={() => setShowAllRules(!showAllRules)}
                  className="mt-1 text-xs text-gray-500"
                >
                  {showAllRules ? "See less.." : "See more.."}
                </button>
              </div>
            </div>
            {paymentMethod.length === 0 ? (
              <div className="w-full mt-2.5 rounded-[10px] bg-bg_color_primary text-center text-red-600 px-3 py-[15px] font-bold text-base">
                Payment method not available
              </div>
            ) : (
              <>
                {selectedOption === "Bank" && (
                  <div className="w-full mt-2.5 rounded-[10px] bg-bg_color_primary text-text_color_primary1 px-3 py-[15px]">
                    <div className="w-full mb-2">
                      <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                        Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                      </span>
                    </div>

                    <div className="font-bold mt-[4px] mb-[8px] text-base leading-5">
                      <span>Payment Details</span>
                    </div>

                    {/* Account Number */}
                    <div className="mb-3">
                      <p className="text-xs text-text_color_tertiary1 mb-1">Account Number</p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.accountNo}</span>
                        <span className="cursor-pointer" onClick={() => handleCopy(methodDetail?.accountNo)} title="Copy">
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>

                    {/* IFSC Code */}
                    <div className="mb-3">
                      <p className="text-xs text-text_color_tertiary1 mb-1">IFSC Code</p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.ifscCode}</span>
                        <span className="cursor-pointer" onClick={() => handleCopy(methodDetail?.ifscCode)} title="Copy">
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>

                    {/* Account Holder Name */}
                    <div className="mb-3">
                      <p className="text-xs text-text_color_tertiary1 mb-1">Account Holder Name</p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.accountHolder}</span>
                        <span className="cursor-pointer" onClick={() => handleCopy(methodDetail?.accountHolder)} title="Copy">
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>

                    {/* Bank Name */}
                    <div>
                      <p className="text-xs text-text_color_tertiary1 mb-1">Bank Name</p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.bankName}</span>
                        <span className="cursor-pointer" onClick={() => handleCopy(methodDetail?.bankName)} title="Copy">
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {["Gpay", "Phonepe", "UPI", "Paytm"].includes(selectedOption) && (
                  <div className="w-full mt-2.5 rounded-[10px] bg-bg_color_primary text-text_color_primary1 px-3 py-[15px]">
                    <div className="w-full mb-2">
                      <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                        Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                      </span>
                    </div>

                    <div className="font-bold mt-[4px] mb-[8px] text-base leading-5">
                      <span>Payment Details</span>
                    </div>

                    {/* Dynamic ID Field */}
                    <div className="mb-3">
                      <p className="text-xs text-text_color_tertiary1 mb-1">
                        {selectedOption === "Phonepe"
                          ? "PhonePe Number"
                          : selectedOption === "Paytm"
                            ? "Paytm Number"
                            : selectedOption === "Gpay"
                              ? "Google Pay ID"
                              : "UPI ID"}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.upiId}</span>
                        <span
                          className="cursor-pointer"
                          onClick={() => handleCopy(methodDetail?.upiId)}
                          title="Copy"
                        >
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>

                    {/* Holder Name */}
                    <div>
                      <p className="text-xs text-text_color_tertiary1 mb-1">Holder Name</p>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">{methodDetail?.holderName}</span>
                        <span
                          className="cursor-pointer"
                          onClick={() => handleCopy(methodDetail?.holderName)}
                          title="Copy"
                        >
                          <span>{CopyIcon}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                )}


                {["QRCODE"].includes(selectedOption) && (
                  <div className="w-full mt-2.5 rounded-[10px] bg-bg_color_primary text-text_color_primary1 px-3 py-[15px]">
                    <div className="w-full mb-2">
                      <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                        Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                      </span>
                    </div>

                    <div>
                      <div className="font-bold mt-[4px] mb-[8px] text-base leading-5">
                        <span>SCAN QR</span>
                      </div>

                      <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                        <Image
                        width={200}
                          src={`${Appconfig.apiUrl}banner/${methodDetail.qrCode}`}
                        />
                      </span>
                    </div>
                  </div>
                )}

                {selectedOption === "USDT" && usdtMethods.length > 0 && (
                  <div className="w-full mt-2.5 rounded-[10px] bg-bg_color_primary text-text_color_primary1 px-3 py-[15px]">
                    <div className="w-full mb-2">
                      <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                        Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                      </span>
                    </div>
                    <div className="font-bold mt-[4px] mb-[8px] text-base leading-5">
                      <span>USDT Payment Details</span>
                    </div>
                    {usdtMethods.map((usdt, idx) => (
                      <div key={usdt._id} className="mb-6">
                        <div className="mb-3">
                          <p className="text-xs text-text_color_tertiary1 mb-1">USDT Wallet Address</p>
                          <div className="flex items-center justify-between">
                            <span className="font-semibold text-sm">{usdt.upiId}</span>
                            <span className="cursor-pointer" onClick={() => handleCopy(usdt.upiId)} title="Copy">
                              <span>{CopyIcon}</span>
                            </span>
                          </div>
                        </div>
                        <div>
                          <p className="text-xs text-text_color_tertiary1 mb-1">Holder Name</p>
                          <div className="flex items-center justify-between">
                            <span className="font-semibold text-sm">{usdt.holderName}</span>
                            <span className="cursor-pointer" onClick={() => handleCopy(usdt.holderName)} title="Copy">
                              <span>{CopyIcon}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            <div className="w-full mt-2.5 rounded-md bg-bg_color_primary text-text_color_primary1 py-3.5 px-3">
              <div className="font-bold text-base leading-5">
                Upload your payment slip below
              </div>

              <div className="w-full relative mt-2">
                <label htmlFor="paymentSlip" style={{ width: "100%" }}>
                  <div className="flex items-center border border-dashed rounded-[4px] py-3 pl-3 pr-1 border-border_color_brand_primary cursor-pointer">
                    <input
                      id="paymentSlip"
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf,.webp"
                      className="hidden w-0 h-0 text-text_color_primary1"
                      onChange={(e) => handleImageUpload(e)}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg"
                      width="24" height="24" viewBox="0 0 24 24" fill="none">
                      {/* Upload Icon Path */}
                      <path
                        d="M21.7491 10.9999V16.9999C21.8078 17.5066 21.7512 18.0199 21.5835 18.5016C21.4158 18.9833 21.1414 19.4209 20.7807 19.7815C20.42 20.1422 19.9825 20.4166 19.5008 20.5843C19.0191 20.752 18.5057 20.8086 17.9991 20.7499H5.99906C5.4924 20.8086 4.97902 20.752 4.49732 20.5843C4.01563 20.4166 3.57808 20.1422 3.21742 19.7815C2.85676 19.4209 2.58232 18.9833 2.41463 18.5016C2.24694 18.0199 2.19034 17.5066 2.24906 16.9999V6.9999C2.19034 6.49324 2.24694 5.97986 2.41463 5.49817C2.58232 5.01647 2.85676 4.57893 3.21742 4.21827C3.57808 3.8576 4.01563 3.58316 4.49732 3.41547C4.97902 3.24778 5.4924 3.19118 5.99906 3.2499H13.9991C14.198 3.2499 14.3887 3.32892 14.5294 3.46957C14.67 3.61023 14.7491 3.80099 14.7491 3.9999C14.7491 4.19882 14.67 4.38958 14.5294 4.53023C14.3887 4.67089 14.198 4.7499 13.9991 4.7499H5.99906C4.42206 4.7499 3.74906 5.4229 3.74906 6.9999V16.2499L6.28906 13.7099C6.47787 13.5226 6.73307 13.4174 6.99906 13.4174C7.26505 13.4174 7.52025 13.5226 7.70906 13.7099L8.64906 14.6499C8.74252 14.7415 8.86818 14.7928 8.99906 14.7928C9.12994 14.7928 9.2556 14.7415 9.34906 14.6499L14.2891 9.7099C14.4779 9.52255 14.7331 9.41742 14.9991 9.41742C15.265 9.41742 15.5203 9.52255 15.7091 9.7099L20.2491 14.2499V10.9999C20.2491 10.801 20.3281 10.6102 20.4687 10.4696C20.6094 10.3289 20.8001 10.2499 20.9991 10.2499C21.198 10.2499 21.3887 10.3289 21.5294 10.4696C21.67 10.6102 21.7491 10.801 21.7491 10.9999Z"
                        fill="var(--icon-color-primary)">
                      </path>
                    </svg>
                    <div className="flex-1 flex justify-start gap-x-1 items-start">
                      <span className="cursor-pointer font-inherit text-base text-text_color_tertiary1 font-normal">
                        {imageList ? imageList.name : "Upload or drop a file right here"}
                      </span>
                      {/* <span className="font-inherit text-base text-text_color_tertiary1 font-normal">
                        or drop a file right here
                      </span> */}
                    </div>
                  </div>
                </label>
              </div>
              <span></span>
            </div>

            <div className="w-full mt-2.5 bg-bg_color_primary text-text_color_primary1 rounded-md px-3 py-3.5">
              <div className="flex flex-col w-full">
                <div className="font-bold text-sm mb-2 leading-5">
                  Unique Transaction Reference
                </div>
                <div className="flex items-center w-full text-text_color_primary1 text-sm md:text-base bg-bg_color_input_bg rounded-[4px] border border-border_color_primary">
                  <input
                    className="w-full h-full px-3 py-2.5 flex-grow min-w-0 border-none focus:outline-none bg-transparent"
                    type="text"
                    inputMode="numeric"
                    placeholder="Upto 12 Digits UTR/RRN Number"
                    value={utrValue}
                    onChange={(e) => setUTRValue(e.target.value)}
                  />
                </div>
                <div className="flex items-start w-full justify-between leading-normal px-1">
                  <div className="w-max h-max"></div>
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center gap-x-2 py-3 px-5">
              <div className="inline-flex items-center">
                <label
                  className="relative flex cursor-pointer items-center rounded-full bg-bg_color_quaternary4 "
                  for="blue">
                  <input
                    className="before:content[''] before:bg-bg_color_quaternary8 rounded-md peer relative  cursor-pointer appearance-none border border-success transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-max before:w-max before:-translate-x-2/4 before:-translate-y-2/4 before:opacity-0 before:transition-opacity checked:border-success checked:bg-bg_color_success hover:before:opacity-10 h-5 w-5"
                    id="blue" type="checkbox" checked />
                  <span
                    className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-text_color_primary2 opacity-0 transition-opacity peer-checked:opacity-100">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20"
                      fill="currentColor" stroke="currentColor" strokeWidth="1">
                      <path fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span className="text-sm text-text_color_primary1 font-lato font-[400] leading-5">I have read and
                agree with <span
                  className="bg-bg_text_brand_primary text-transparent bg-clip-text underline text-sm font-lato font-[400] leading-4 cursor-pointer">the
                  terms of payment and withdrawal policy.</span></span>
            </div>

            <div className=" w-full bottom-0 pb-[10px] app-bg">
              <button
                id="btn"
                type="submit"
                disabled={isSubmitted}
                className={`bg-bg_text_brand_primary flex items-center justify-center gap-x-2 w-full text-text_color_primary2 h-10 text-base rounded-md font-[500] leading-4 disabled:opacity-70 relative ${isSubmitted ? "activated" : ""}`}
              >
                <span>{buttonText}</span>
                <div className="checked">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path
                      fill="transparent"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    ></path>
                  </svg>
                </div>
              </button>
            </div>

          </form>

        </div>
      </div >

      <div className="w-full flex flex-row items-center justify-center gap-3 mt-2 flex-wrap">
        <button
          onClick={handleToggleNotes}
          className="px-4 py-2 text-white bg-[#0c9971] rounded font-semibold"
        >
          {showNotes ? "Hide" : "See How TO Deposit"}
        </button>

        <button
          onClick={handleToggleHistory}
          className="px-4 py-2 bg-[#0c9971] text-white rounded font-semibold"
        >
          {showDepositHistory ? "Hide Deposit History" : "Show Deposit History"}
        </button>
      </div>



      {/* <div className="w-full h-max flex flex-col items-center justify-start mb-2 mt-10"> */}
        {/* <button
          onClick={() => setShowNotes(!showNotes)}
          className="px-4 py-2 text-white bg-[#0c9971] rounded font-semibold"
        >
          {showNotes ? "Hide" : "See How TO Deposit"}
        </button> */}

        {showNotes && (
          <div ref={notesRef} className="w-full flex flex-col items-center justify-start bg-bg_color_primary text-text_color_primary1 px-3 py-[15px] rounded-md mt-4">
            <h2 className="w-full text-base font-bold">Notes</h2>
            <div className="w-full flex items-center justify-start mt-5 gap-y-4 flex-col">

              {/* Step 1 */}
              <div className="flex w-full flex-row items-start gap-x-2 justify-start">
                <span className="p-1.5 min-w-3 min-h-3 aspect-square bg-bg_color_brand_primary1 flex items-center justify-center rounded-full text-[10px] text-text_color_primary2 font-bold">
                  1
                </span>
                <div className="flex items-start justify-start flex-col gap-y-1">
                  <span className="font-bold text-sm leading-4">Send Amount</span>
                  <span className="text-text_color_tertiary2 font-medium text-[13px] leading-4">
                    Send your deposit amount on the given bank account.
                  </span>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex w-full flex-row items-start gap-x-2 justify-start">
                <span className="p-1.5 min-w-3 min-h-3 aspect-square bg-bg_color_brand_primary1 flex items-center justify-center rounded-full text-[10px] text-text_color_primary2 font-bold">
                  2
                </span>
                <div className="flex items-start justify-start flex-col gap-y-1">
                  <span className="font-bold text-sm leading-4">Attach Screenshot</span>
                  <span className="text-text_color_tertiary2 font-medium text-[13px] leading-4">
                    <div className="w-full flex flex-col items-start justify-start">
                      <span>Copy and Enter the 12 digit UTR Number.</span>

                      {/* Example Box */}
                      <div className="mt-4 flex flex-col w-full items-center border border-notesBorderColor rounded-[15px]">
                        <div className="px-4 py-2.5 flex items-start justify-start gap-x-[5px] border-b border-notesBorderColor w-full">
                          {/* Status Icon */}
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <circle cx="8" cy="8" r="8" fill="var(--icon-color-brand-secondary)" />
                            <path
                              d="M12.0542 6.30469L7.72083 10.6379C7.59082 10.7679 7.42017 10.8334 7.24951 10.8334C7.07886 10.8334 6.9082 10.7679 6.7782 10.6379L4.61157 8.47131C4.35083 8.21069 4.35083 7.78931 4.61157 7.52869C4.87219 7.26794 5.29346 7.26794 5.5542 7.52869L7.24951 9.224L11.1116 5.36206C11.3722 5.10132 11.7935 5.10132 12.0542 5.36206C12.3148 5.62268 12.3148 6.04395 12.0542 6.30469Z"
                              fill="var(--icon-color-secondary)"
                            />
                          </svg>

                          <div className="flex flex-col w-full">
                            <span className="text-sm font-medium text-text_color_primary1">Paid ₹ 10,000</span>
                            <span className="text-[13px] font-medium text-text_color_primary1">9079313982@indus</span>
                          </div>

                          <div className="float-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path
                                d="M9.99919 13.3334C10.1089 13.334 10.2176 13.313 10.3191 13.2715C10.4206 13.2301 10.513 13.169 10.5909 13.0917L15.5909 8.09174C15.7478 7.93482 15.8359 7.72199 15.8359 7.50007C15.8359 7.27816 15.7478 7.06533 15.5909 6.90841C15.4339 6.75149 15.2211 6.66333 14.9992 6.66333C14.7773 6.66333 14.5644 6.75149 14.4075 6.90841L9.99919 11.3251L5.59086 6.91674C5.43144 6.78022 5.22638 6.70888 5.01665 6.71698C4.80692 6.72508 4.60797 6.81203 4.45956 6.96044C4.31115 7.10885 4.2242 7.3078 4.2161 7.51753C4.208 7.72726 4.27934 7.93232 4.41586 8.09174L9.41586 13.0917C9.57108 13.2457 9.78058 13.3325 9.99919 13.3334Z"
                                fill="var(--icon-color-brand-secondary)"
                              />
                            </svg>
                          </div>
                        </div>

                        {/* Other sample content */}
                        <div className="mt-3 px-[9px] w-full gap-[3px]">
                          <div className="px-[9px] py-1.5 border border-border_color_primary w-full flex flex-col items-start justify-start rounded-md">
                            <span className="text-text_color_tertiary2 text-[13px] font-medium leading-4">UPI Transaction Id</span>
                            <span className="text-text_color_primary1 text-[13px] font-medium leading-4">925109698898</span>
                          </div>
                        </div>
                        <div className="px-[18px] mt-2.5 w-full flex flex-col items-start justify-start">
                          <span className="text-text_color_tertiary2 text-[13px] font-medium leading-4">To: Shop</span>
                          <span className="text-text_color_primary1 text-[13px] font-medium leading-4">9079313982@indus</span>
                        </div>
                        <div className="px-[18px] mt-2.5 w-full flex flex-col items-start justify-start">
                          <span className="text-text_color_tertiary2 text-[13px] font-medium leading-4">From: Lotus (IDFC Bank)</span>
                          <span className="text-text_color_primary1 text-[13px] font-medium leading-4">Lotus18-1@okicici</span>
                        </div>
                        <div className="px-[18px] mt-2.5 mb-4 w-full flex flex-col items-start justify-start">
                          <span className="text-text_color_tertiary2 text-[13px] font-medium leading-4">Google Transaction ID</span>
                          <span className="text-text_color_primary1 text-[13px] font-medium leading-4">CICAhuffk-ec</span>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex w-full flex-row items-start gap-x-2 justify-start">
                <span className="p-1.5 min-w-3 min-h-3 aspect-square bg-bg_color_brand_primary1 flex items-center justify-center rounded-full text-[10px] text-text_color_primary2 font-bold">
                  3
                </span>
                <div className="flex items-start justify-start flex-col gap-y-1">
                  <span className="font-bold text-sm leading-4">Upload Proof</span>
                  <span className="text-text_color_tertiary2 font-medium text-[13px] leading-4">Upload transaction Screenshot.</span>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex w-full flex-row items-start gap-x-2 justify-start">
                <span className="p-1.5 min-w-3 min-h-3 aspect-square bg-bg_color_brand_primary1 flex items-center justify-center rounded-full text-[10px] text-text_color_primary2 font-bold">
                  4
                </span>
                <div className="flex items-start justify-start flex-col gap-y-1">
                  <span className="font-bold text-sm leading-4">Submit</span>
                  <span className="text-text_color_tertiary2 font-medium text-[13px] leading-4">
                    Submit the form & Receive credits instantly.
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      {/* </div> */}


      <div className="mt-8 mb-8">
        {/* <button
          onClick={() => setShowDepositHistory(!showDepositHistory)}
          className="px-4 py-2 bg-[#0c9971] text-white rounded font-semibold"
        >
          {showDepositHistory ? "Hide Deposit History" : "Show Deposit History"}
        </button> */}

        {/* {showDepositHistory && (
          <div ref={historyRef} className="mt-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-900">
              Deposit History
            </h3>
            <div className="overflow-x-auto">
              <Table
                columns={historyColumns}
                className="min-w-full border border-gray-200 rounded-lg bg-white custom-white-table"
                bordered
                dataSource={depositHistory}
                pagination={true}
              />
            </div>
          </div>
        )} */}
        {showDepositHistory && (
          <div ref={historyRef} className="mt-4">
            <div className="bg-white shadow-lg rounded-2xl p-1">
              <h3 className="text-2xl font-bold mb-2 text-gray-900">
                Deposit History
              </h3>
              <div className="overflow-x-auto">
                <Table
                  columns={historyColumns.map((col) => ({
                    ...col,
                    onHeaderCell: () => ({
                      style: {
                        backgroundColor: "#0c9971",
                        color: "white",
                        fontWeight: 600,
                        textAlign: "center",
                      },
                    }),
                  }))}
                  dataSource={depositHistory}
                  pagination={{ pageSize: 10 }}
                  bordered
                  rowClassName="hover:bg-gray-50"
                  className="rounded-lg overflow-hidden"
                  scroll={{ x: "max-content" }}
                />

              </div>
            </div>

            {/* Screenshot Modal */}
            <Modal
              open={previewVisible}
              footer={null}
              onCancel={() => setPreviewVisible(false)}
              centered
            >
              <img alt="screenshot" className="w-full rounded-lg" src={previewImage} />
            </Modal>
          </div>

        )}
        
      </div>

    </>
  );
};

export default Deposit;
